import { FetchError } from "./FetchError";
import { ERROR_RESPONSE } from "../codeResponses/codes";
import { Toast } from "./../../components/UI/toast/Toast";
import {
  TOO_MANY_REQUESTS_MESSAGE,
  isTooManyRequests,
  notifyTooManyRequests,
} from "./tooManyRequests";
import { ACCOUNT_WITHOUT_PROPERTIES_MESSAGE } from "./accountWithoutProperties";

const handleErrorMessage = (error) => {
  // HO-TASK-297: el 429 trae en `message` cuántos segundos esperar. Usa el
  // mismo aviso que fetch.js, así no se muestra dos veces.
  const tooManyRequests = [error, error?.data].find(isTooManyRequests);
  if (tooManyRequests) {
    notifyTooManyRequests(tooManyRequests);
    return;
  }

  let message =
    "Ha ocurrido un error inesperado, por favor reintenta nuevamente.";

  if (error) {
    if (error.error) {
      message = error.error;
    } else if (error.errors) {
      const fieldErrors = Object.values(error.errors).flat();
      if (fieldErrors.length > 0) {
        message = fieldErrors[0];
      }
    } else if (error.code) {
      message = getErrorMessage(error.code);
    } else if (error instanceof FetchError) {
      const { data } = error;
      const fieldErrors = data?.errors && Object.values(data.errors).flat();
      if (fieldErrors?.length > 0) {
        message = fieldErrors[0];
      } else {
        message = data?.error || getErrorMessage(data?.code);
      }
    }
  }

  Toast.fire({
    type: "error",
    title: message,
  });
};

export const getErrorMessage = (code) => {
  switch (code) {
    case ERROR_RESPONSE.FORBIDDEN:
      return "No posees permisos suficientes para realizar esta acción.";
    case ERROR_RESPONSE.INVALID_CREDENTIALS:
      return "Credenciales invalidas.";
    case ERROR_RESPONSE.TOKEN_EXPIRED:
      return "Token expirado.";
    case ERROR_RESPONSE.INVALID_TOKEN:
      return "El token ingresado es invalido.";
    case ERROR_RESPONSE.UNVERIFIED:
      return "Su cuenta no ha sido verificada.";
    case ERROR_RESPONSE.BAD_REQUEST:
      return "Petición invalida, por favor verifique los datos enviados al servidor.";
    case ERROR_RESPONSE.DATA_NOT_FOUND:
      return "El recurso solicitado no existe.";
    case ERROR_RESPONSE.UNPROCESSABLE_DATA:
      return "No se ha podido procesar la data.";
    case ERROR_RESPONSE.MAX_DEVICE:
      return "Ha alcanzado el máximo de dispositivos conectados.";
    case ERROR_RESPONSE.PENDING_ALREADY_EXIST:
      return "Ya tiene un pago pendiente por aprobación.";
    case ERROR_RESPONSE.VOTING_ALREADY_DONE:
      return "Usted ya ha votado.";
    case ERROR_RESPONSE.DATE_NOT_ACCEPTABLE:
      return "Ese rango de fechas ya existe.";
    case "H0021":
      return "La votación ya expiró.";
    case ERROR_RESPONSE.UNFINISHED_VOTING:
      return "La votación no ha concluido.";
    case "H0024":
      return "Tienes una reserva que no ha concluído.";
    case "H0034":
      return "Saldo insuficiente.";
    case "H0035":
      return "Saldo insuficiente.";
    case "H0026":
      return "Fecha inválida.";
    case "H0042":
      return "Solo se puede editar el monto de un aporte activo.";
    case "H0043":
      return "La moneda de trabajo no se puede cambiar porque el condominio ya tiene actividad financiera registrada.";
    case ERROR_RESPONSE.TOO_MANY_REQUESTS:
      return TOO_MANY_REQUESTS_MESSAGE;
    case ERROR_RESPONSE.ACCOUNT_WITHOUT_PROPERTIES:
      return ACCOUNT_WITHOUT_PROPERTIES_MESSAGE;
    default:
      return "Ha ocurrido un error inesperado, por favor reintenta nuevamente.";
  }
};

export default handleErrorMessage;
